import React, { useState } from 'react';
import Tooltip from '../../../shared/components/Tooltip/Tooltip';
import Dialog from './QuoteDialog';

export default function QuoteHelp({ title, children }) {
  const [open, setOpen] = useState(false);
  return <>
    <Tooltip portal label={children}><button type="button" className="quote-help" aria-label={`Aide : ${title}`} onClick={event => { event.preventDefault(); event.stopPropagation(); setOpen(true); }}>?</button></Tooltip>
    <Dialog open={open} onClose={() => setOpen(false)} title={title}><p>{children}</p></Dialog>
  </>;
}
